import {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import LoadingSpinner from "../../components/Controls/LoadingSpinner/LoadingSpinner";
import "../../components/Pages/Code/Code.css";
import Select, { NonceProvider } from "react-select";
import "../../../src/Shared/Css/countryFlagStyles.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const PersonalInfo = forwardRef(function PersonalInfo({}, ref) {
  const navigate = useNavigate();
  const translationsMap = useSelector(
      (state) => state.languageTranslation.translationsMap
  );
  const [openLoader, setOpenLoader] = useState(false);
  const [modelMessage, setModelMessage] = useState("");
  const [personalInfoText, setReader_PersonalInfoText] = useState("");
  const [firstNameText, setReader_FirstNameText] = useState("");
  const [lastNameText, setReader_LastNameText] = useState("");
  const [continueText, setReader_ContinueText] = useState("");
  const [Reader_ID, setReader_ID] = useState("");
  const [mobileNum, setMobileNum] = useState("");
  const [modelopen, setOpen] = useState(false);
  const [selectOptions, setSelectOptions] = useState([]);
  const [mobileCountryCode, setMobileCountryCode] = useState("");
  const [NavigatingBnPagesPleaseWait, setReader_NavigatingBnPagesPleaseWait] =
    useState("");
  const [Reader_LoadingPleaseWait, setReader_LoadingPleaseWait] = useState("");
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  //const mobileNum = useRef("");
  const selectCountryCode = useRef("");

  const redirectUrlRef = useRef("");
  const rpdInfoData = useRef({});
  const documentId = useRef("");
  // const countryCodes = useRef([]);
  const communicationChannel = useRef({});
  const readerOk = useRef("");
  const [openPersonalInfo, setOpenPersonalInfo] = useState(false);
  //const disclaimerRef =useRef(null);

  useImperativeHandle(ref, () => {
    return {
      // getRedirectUrl() {
      //   return redirectUrlRef.current;
      // },
      onShow(
        isOpen,
        rpdRecipientInfo,
        docId,
        countryCodes,
        communication,
        //errorMessage,
        reader_Ok
      ) {
        setOpenPersonalInfo(isOpen);
        rpdInfoData.current = { ...rpdRecipientInfo };
        documentId.current = docId;
        setSelectOptions(() => {
          return [...countryCodes];
        });
        communicationChannel.current = communication;
        readerOk.current = reader_Ok;
        //getLanguageTranslations();
      },
    };
  });

  // useEffect(() => {
  //   getLanguageTranslations();
  // }, []);
  async function getLanguageTranslations() {
    const browserlanguage = window.navigator.language;
    const url = `${process.env.REACT_APP_API}/docs/languagetranslations/${documentId.current}/${browserlanguage}`;
    let json;
    try {
      var res = await fetch(url);
      json = await res.json();
      console.log(json);
      //setLanguageTranslations(json.data);
      json.data.forEach((element) => {
        if (element.id === "4ea2bad6-654f-4b75-bdf8-aae6c0e76beb")
          setReader_PersonalInfoText(element.description);
        else if (element.id === "d06b0568-96aa-47f4-90d7-ef467c1e91ad")
          setReader_FirstNameText(element.description);
        else if (element.id === "51e99a8f-4a31-47b5-a2ff-f530f3b9b2a6")
          setReader_LastNameText(element.description);
        else if (element.id === "B5EBC09A-28B3-4F66-8C8A-AD479D9B33B1")
          setReader_ContinueText(element.description);
        else if (element.id === "088dcf20-c3a7-489d-83c1-9a6b8030dc21")
          setReader_NavigatingBnPagesPleaseWait(element.description);
        else if (element.id === "0198A1C3-A616-4383-9CA1-2B686E7B2161")
          setReader_ID(element.description);
        else if (element.id === "c77447de-ae4a-42a9-9f82-f8bf21ed8d57")
          setReader_LoadingPleaseWait(element.description);
      });
    } catch (error) {}
  }
  function handleMobileNum(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setMobileNum(event.target.value.trim());
    }
  }
  const handleMobileCountryCode = (e) => {
    if (e.languageCode == "ca") {
      const updatedOptions1 = selectOptions.map((option) => {
        // Check if the languageCode is "us", and if so, update the value
        if (option.languageCode != "ca" || option.languageCode == "") {
          return {
            ...option,
            value: `${
              option.value.split("-")[0]
            }-${option.languageCode.toUpperCase()}`,
          }; // Update value for US
        }
        // Leave other options unchanged
        return option;
      });
      setSelectOptions(updatedOptions1);
    }
    if (e.languageCode == "us") {
      const updatedOptions2 = selectOptions.map((option) => {
        // Check if the languageCode is "us", and if so, update the value
        if (option.languageCode != "us" || option.languageCode == "") {
          return {
            ...option,
            value: `${
              option.value.split("-")[0]
            }-${option.languageCode.toUpperCase()}`,
          }; // Update value for US
        }
        // Leave other options unchanged
        return option;
      });
      setSelectOptions(updatedOptions2);
    }
    e.value = e.value.split("-")[0];
    setMobileCountryCode(e);
  };
  const handleToClose = () => {
    setOpenLoader(false);
    setOpen(false);
  };
    const globePlaceholder = {
    label: "+Code",
    value: "+Code",
    languageCode: "+Code", // Used to show the globe icon
    isPlaceholder: true
  };
  const handlePersonalInfo = () => {
    if (
      (mobileCountryCode.value == undefined ||
        mobileCountryCode.value == "Country Code") &&
      mobileNum != ""
    ) {
      setOpen(true);
      setModelMessage("Please select country code.");
      return;
    }

    const selectedCountry = selectOptions.find(
      (option) => option.value.split("-")[0] === mobileCountryCode?.value
    );

    const maxLength = selectedCountry ? selectedCountry.mobileMaxLeng : 10; // Default to 10 if no country is selected

    // Check if the input exceeds the max length
    if (
      mobileNum.length != maxLength &&
      mobileCountryCode.value !== "Country Code" &&
      mobileCountryCode.value
    ) {
      setOpen(true);
      setModelMessage("Please enter valid mobile number.");
      return;
    }
    setOpen(false);
    setOpenLoader(true);
    let firstName = firstNameRef.current.value.trim();
    let lastName = lastNameRef.current.value.trim();
    let MobileCountryCode =
      mobileCountryCode.value == undefined ||
      mobileCountryCode.value == "Country Code"
        ? ""
        : mobileCountryCode.value;
    let MobileNumber = mobileNum;
    if (firstName.length === 0) firstName = "";
    if (lastName.length === 0) lastName = "";
    var url = `${process.env.REACT_APP_API}/docs/read/${documentId.current}`;
    console.log({ ...rpdInfoData.current, firstName, lastName });
    const rpdInfo = {
      ...rpdInfoData.current,
      firstName,
      lastName,
      MobileCountryCode,
      MobileNumber,
    };
    fetch(url, {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rpdInfo),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        if (
          response.errorMessage != "" &&
          response.errorMessage == "Duplicate mobile number"
        ) {
          setOpen(true);
          setOpenLoader(false);
          setModelMessage("Duplicate mobile number is not allowed.");
          return;
        }
        if (response.authenticated) {
          //setOpenLoader(false);
          console.log(documentId.current);
          console.log(response.recipientId);
          // setCookie(
          //   documentId,
          //   response.recipientId,
          //   response.sessionExpireDate
          // );
          setOpenLoader(false);
          setOpenPersonalInfo(false);
          // disclaimerRef.current.open(response.redirectUrl);
          //redirectUrlRef.current = response.redirectUrl;
          const redirectPath = new URL(response.redirectUrl).pathname;
          navigate(redirectPath, { 
            replace: true,
            state: {
              translationsMap: {...translationsMap} 
            }
          });
          //window.open(response.redirectUrl, "_self");
          
        }
      })
      .catch((error) => {
        setOpenLoader(false);
        console.log("Document read error");
      });
  };
  let content = <></>;
  if (communicationChannel.current.text && communicationChannel.current.whatsApp) {
    content = (
      <>
        <option value="Text">Text</option>
        <option value="WhatsApp">WhatsApp</option>
      </>
    );
  } else if (communicationChannel.current.whatsApp) {
    content = <option value="WhatsApp">WhatsApp</option>;
  } else if (communicationChannel.current.text) {
    content = <option value="Text">Text</option>;
  }
  return (
    <>
      {openPersonalInfo && (
        <>
          {openLoader && (
            <div className="spinerAuth-text ">
              <LoadingSpinner
                authenticatingMsg={translationsMap.Reader_LoadingPleaseWait}
                class={"codeJs"}
              />
            </div>
          )}
          <div
            className="rpdFont modal"
            id="PagewModel"
            style={{ display: "block", backgroundColor: "#54404061" }}
            onContextMenu={(e) => e.preventDefault()}>
            <div className="modal-dialog modal-dialog-centered modal-customelg">
              <div className="modal-content">
                <div className="modal-body mt-0">
                  <div className="rpdFont ">
                    <div
                      className="rpdFont d-flex flex-column justify-content-center"
                      style={{ color: "#040921" }}>
                      <h1 className="text-center mb-0 mt-1 font-20px  res-font14 ">
                        {translationsMap.Reader_PersonalInfoText}
                      </h1>
                    </div>

                    <div className="rpdFont input-group mb-3 pb-2 mt-3 d-flex  justify-content-center">
                      <div className="input-group-append">
                        <span className="input-group-text rp-text">
                          <i
                            className="material-icons"
                            style={{
                              fontSize: "22px",
                              color: "#ffff",
                            }}>
                            person
                          </i>
                        </span>
                      </div>
                      <input
                        type="text"
                        ref={firstNameRef}
                        className="rpdFont form-control input_Person "
                        placeholder={translationsMap.firstNameRef}
                        maxLength={50}
                        // value={verifyEmail}
                        autoComplete="given-name"></input>
                    </div>
                    <div className="rpdFont input-group mb-3 d-flex  justify-content-center">
                      <div className="input-group-append">
                        <span className="input-group-text rp-text">
                          <i
                            className="material-icons"
                            style={{ fontSize: "22px", color: "#ffff" }}>
                            person
                          </i>
                        </span>
                      </div>

                      <input
                        type="text"
                        ref={lastNameRef}
                        className="rpdFont form-control input_Person "
                        placeholder={translationsMap.lastNameRef}
                        maxLength={50}
                        // value={passcode}
                        autoComplete="family-name"
                        //autoComplete="new-password"
                      ></input>
                    </div>

                    <div className="">
                      {(communicationChannel.current.text ||
                        communicationChannel.current.whatsApp) && (
                        <div className="rpdFont input-group mb-3 mt-4 d-flex justify-content-center mobile-select">
                          <div className="input-group-append">
                            <span className="input-group-text rp-text">
                              <i
                                className="material-icons"
                                style={{ fontSize: "22px", color: "#ffff" }}>
                                phone_iphone
                              </i>
                            </span>
                          </div>
                          <Select
                            value={mobileCountryCode?.value ? mobileCountryCode : globePlaceholder}
                            onChange={handleMobileCountryCode}
                            placeholder="Country Code"
                            options={selectOptions}
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                height: "40px",
                                width: "130px",
                                border: "1px solid #ccc",
                                borderRadius: "0px 0 0 0px",
                                boxShadow: "none",
                                cursor: "pointer",
                                wordBreak: "normal",
                                // width: 'fit-content',
                                whiteSpace: "nowrap",
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                                width: "253px",
                                //marginTop: '18px',
                                maxHeight: "353px", // Limit height for scrolling
                                overflowY: "auto", // Enable vertical scrolling
                              }),
                              menuPortal: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                              indicatorSeparator: () => ({
                                display: "none",
                              }),
                            }}
                            //menuPortalTarget={document.body}
                            menuPosition="absolute"
                            //menuShouldScrollIntoView={false}
                            getOptionLabel={(e) => `${e.label}`}
                            getOptionValue={(e) => `${e.value}`}
                            formatOptionLabel={(data, { context }) => (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}>
                                <div
                                  className={`${data.label === "+Code"
                                                ? "bg-  "
                                                : `bg-${data.languageCode}`
                                                }`}
                                  style={{
                                    width: "36px",
                                    height: "16px",
                                    marginRight: "8px",
                                  }}></div>
                                {context === "menu"
                                  ? `${data.label}`
                                  : `${data.value.split("-")[0]}`}
                              </div>
                            )}
                            noOptionsMessage={() => null}
                          />
                          <input
                            id="mobile"
                            type="text"
                            className="rpdFont form-control input_user input-mobile"
                            placeholder={"Mobile"}
                            value={mobileNum}
                            onChange={handleMobileNum}
                            //onKeyUp={(e) => handleKeyUp(e)}
                          ></input>
                          {communicationChannel.current.text &&
                            communicationChannel.current.whatsApp && (
                              <select id="options">
                                <option value="">{"Select"}</option>
                                {content}
                              </select>
                            )}
                        </div>
                      )}
                    </div>
                    {/* <div className="rpdFont input-group mb-3 d-flex  justify-content-center">

        </div> */}
                    <div className="rpdFont d-flex justify-content-center mt-4 pt-1 login_container">
                      <button
                        type="submit"
                        name="button"
                        className="rpdFont btn login_btn  rp-btn"
                        style={{ lineHeight: "1.6", fontSize: "17px" }}
                        onClick={handlePersonalInfo}>
                        {translationsMap.Reader_Continue}
                      </button>
                    </div>
                    <div className="rpdFont">
                      <p className="rpdFont mb-0 doc-id">
                        {translationsMap.Reader_ID} {documentId.current}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {modelopen === true && (
            <div
              className="modal"
              id="myModal1"
              style={{ display: "block", backgroundColor: "#8080801c" }}>
              <div className="modal-dialog modal-dialog-centered modal-customelg">
                <div className="modal-content">
                  <div className="modal-body" style={{ padding: "0.9rem" }}>
                    <h5
                      className={"text-center my-4 res-font14 rpdFont rd-text"}>
                      <span class="text-warn-text text-wrap-custom">
                        {modelMessage}
                      </span>
                    </h5>

                    <div className="mb-3 justify-content-center d-flex">
                      <button
                        type="button"
                        className="btn btn-secondary w-50 py-2"
                        data-bs-dismiss="modal"
                        style={{
                          background: "#040921",
                        }}
                        onClick={handleToClose}>
                        {readerOk.current}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* <Disclaimer ref={disclaimerRef} /> */}
    </>
  );
});

export default PersonalInfo;
